module.exports = __webpack_public_path__ + "img/more-menu-high-contrast.e51faab8.svg";